import{a as r}from"./chunk-FZHIMCK6.js";import{a as n}from"./chunk-WIMGWYZL.js";function i(...o){return n(r(Math.round),o)}export{i as a};
